<template>
  <v-container v-if="computedShow">
    <v-spacer />
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">
          <v-icon>add</v-icon>Fundview
        </v-btn>
      </template>
      <v-list>
        <v-list-tile :to="{name:'paymentAdd'}">
          <v-list-tile-title>Payment</v-list-tile-title>
        </v-list-tile>
        <v-list-tile :to="{name:'receiptAdd'}">
          <v-list-tile-title>Receipt</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-container>
</template>

<script>
export default {
  name: "Salesbar",
  computed: {
    computedShow() {
      const routes = [
        "paymentsDiary",
        "payment",
        "paymentAdd",
        "receiptsDiary",
        "receipt",
        "receiptAdd"
      ];
      if (routes.includes(this.$route.name)) {
        return true;
      }
      return false;
    }
  }
};
</script>
